<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        Edit Payments
    </template>
    <template slot="body">
       
         <TextField
            class="m1"
            :id="'payment_date'"
            type="date"
            v-bind="textFieldConfig"
            :value="payment_date"
            
            :placeholder="'Payment Date'"
            @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
            class="m1"
            :id="'matching_date'"
            type="date"
            v-bind="textFieldConfig"
            :value="matching_date"
            
            :placeholder="'Matching Date'"
            @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
            class="m1"
            :id="'payment_amount'"
            
            v-bind="textFieldConfig"
            :value="payment_amount"
            
            :placeholder="'amount'"
            @valuechanged="onTextFieldValueChange"
        ></TextField>
            <TextField
            class="m1"
            :id="'payment_external_ref'"
            
            v-bind="textFieldConfig"
            :value="payment_external_ref"
            
            :placeholder="'Invoice No.'"
            @valuechanged="onTextFieldValueChange"
        ></TextField>

    </template>
    <template slot="options">
      
        <button class="dt-button s7" @click="onCancelClick">Cancel</button>
        <button class="dt-button s7 v1" @click="onOKClicked">OK</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';
import { RoyaltyStoreNamespace as storeNS } from "../../store";
// import { mapGetters, mapActions } from "vuex";
// import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
// import { Subject } from "rxjs";
// import {
//   distinctUntilChanged,
//   debounceTime,
// } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

//import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";
// import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
// import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";





import {
  createTV,

} from "../../../../models/text-value.model";

import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import { statementGetters } from '../../store/statement/getters';
import { statementActions } from '../../store/statement/actions';
import { statementServices } from '../../services/statements/statements.service';

import { MHTTPCL } from '../../../../services/http/http-client';

// import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
// export const releaseListAdvancedSearchConfig = createAdvancedSearchConfig(
//   {
//     searchConfigStringKeys: [
      
//       "artist",
//       "title",
//       "start_date",
//       "end_date",
//       "indentifier",
//       "release_status",
//       "label_id",
//       "release_type",
//     ],
//     searchConfigTVMap: [
//       ["label_id", "labelsTV"],
//       ["release_type", "releaseTypeTV"],
//       ["release_status", "releaseStatusesTV"],
    
//     ],
//     // booleanSearchKeyLabelMap: {
//     //   barcode_catalog_error: "Barcode Error",
//     // },
//   }
// );

export default {
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const res=await statementServices.cleanShopNames();
    console.log("SHOP",res)
    
    this.shopList=res.data.shops
    this.digitalAccounts=res.data.digital_accounts;
    this.physicalAccounts=res.data.physical_accounts;

  },
  data: function () {
    return {
        payment_external_ref:"",
        payment_amount:"",
        matching_date:"",
        payment_date:"",
        textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
    
    };
  },
   mixins: [
    
    // createLDTHost(LDTConfig),
    
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
    
  ],

  computed: {
    // ...mapGetters(storeNS, {
    //   releasesCatalogData: "releasesCatalogData",
      
     
    // }),
    ...mapGetterObject(storeNS,statementGetters),
  
    accountsTVDigital:function(){
        return createTV(this.digitalAccounts,"account_name","account_id"); 
    },
    accountsTVPhysical:function(){
        return createTV(this.physicalAccounts,"account_name","account_id");
    },
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3
      });
    },
    // list: function() {
    //   if(this.statementList && this.searchString.length==0){
    //     return this.statementList.statements;
    //   }else{
    //     return this.searchResult
    //   }
    //   return [];
    // },

    contactHeaders: function () {
      return [
        createTableHeader("channel", {  }),
        createTableHeader("current_name", { }),
        createTableHeader("new_name", { }),
        createTableHeader("transfer_to_account", { }),
        createTableHeader("mechanical", { text:"Excl Mechanical" }),
        createTableHeader("service_code", {  }),
        createTableHeader("coverage", {  }),
      
      ];
    },
    
  },
  methods: { 
   ...mapActionObject(storeNS, statementActions),
   
   closeModal:function(){
       closeModalRoute(this);
    },
    onCheckBoxChange:function(e,item){
      console.log(e.target.checked);
    },
    onDropDownChange:async function(name,e,item){
      console.log({name,e,item});
      this.shopList=this.shopList.map(p => {
          if (p.relation_id == item.relation_id) {
            return {
              ...p,
              [name]: p.value
            };
          } else {
            return p;
          }
        });
      await MHTTPCL.modify(undefined,item.relation_id,name,e.value,"l_relations");
    },
    onTextFieldValueChange: function (key, value) {
      this[key] = value;
    },
    onOKClicked:function(){

    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>